import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { endpoints, environment } from 'src/environments/environment'

import { Column } from '../../components/table/model/column'
import { UrlUtilService } from '../url-util/url-util.service'

@Injectable({
	providedIn: 'root',
})
export class TableApiService {
	private FILTERS = endpoints.filters
	private COLUMNS = endpoints.columns
	private COLUMNS_FILENAME = endpoints.columns_filename

	constructor(private http: HttpClient, private urlService: UrlUtilService) {}

	getFilters(key: string): Observable<any> {
		const headers = new HttpHeaders({
			'Ocp-Apim-Subscription-Key': environment.OcpApimSubscriptionKey,
			'x-ald-subscription-key': environment.xAldSubscriptionKey,
		})
		return this.http.get<Array<any>>(
			`${this.FILTERS}?${this.urlService.convertObjectToSearchParam({
				fileName: key + '.json',
			})}`,
			{ headers }
		)
	}

	getColumnsByName(key: string): Observable<any> {
		const headers = new HttpHeaders({
			'Ocp-Apim-Subscription-Key': environment.OcpApimSubscriptionKey,
			'x-ald-subscription-key': environment.xAldSubscriptionKey,
		})
		return this.http.get<Array<any>>(
			`${this.COLUMNS_FILENAME}?${this.urlService.convertObjectToSearchParam({
				fileName: key + '.json',
			})}`,
			{ headers }
		)
	}

	getColumns(key: string): Observable<any> {
		const headers = new HttpHeaders({
			'Ocp-Apim-Subscription-Key': environment.OcpApimSubscriptionKey,
			'x-ald-subscription-key': environment.xAldSubscriptionKey,
		})
		return this.http.get<Array<Column>>(
			`${this.COLUMNS}?${this.urlService.convertObjectToSearchParam({
				key,
			})}`,
			{ headers }
		)
	}
}
